import { processPlatformConfiguration } from 'src/apps/dashboard/helpers/ConfigurationProcessingHelpers';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';

export const useBusinessUnitLabelDisplayName = (): string => {
	const { configuration } = useConfiguration();

	if (!configuration?.PLATFORM) {
		return '';
	}

	const { coreLabels } = processPlatformConfiguration(configuration.PLATFORM);
	const [head] = coreLabels.filter((v) => v.label === 'business-unit');

	return head?.displayName ?? '';
};
